import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import axios from 'axios';

import App from './App';
import store from './store/index';
import { BFFbaseURL, appENV } from './config';
import { createCookie } from './utils/common/cookies';

if (appENV === 'local') {
  const mockSonnetAddressBookUid = 'pcext%3A12604';
  createCookie('abuid', mockSonnetAddressBookUid, false, false);
}

axios.defaults.baseURL = BFFbaseURL;
axios.defaults.withCredentials = true;
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <IntlProvider locale="en">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IntlProvider>
  </Provider>,
);
